(() => {
  'use strict';
  const configEl = document.getElementById('nova-agency-config');
  if (!configEl || window.novaAgencyLoaded) return;
  window.novaAgencyLoaded = true;
  const config = JSON.parse(configEl.textContent), t = config.labels;
  const formSelector = '.rsi-form-main', states = new WeakMap();
  let catalog = null, failed = false, scheduled = false;
  const normal = v => String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const canonical = v => ({cuzco:'cusco','provincia constitucional del callao':'callao','cercado de lima':'lima'}[normal(v)] || normal(v));
  const input = (form, id) => form.querySelector(`input#${id}`);
  function write(el, value) {
    if (!el || el.value === value) return;
    Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(el, value);
    el.dispatchEvent(new Event('input', {bubbles:true}));
    el.dispatchEvent(new Event('change', {bubbles:true}));
  }
  function make(tag, cls) {const e = document.createElement(tag); if (cls) e.className = cls; return e;}
  function hide(el, hidden) {if (el) el.classList.toggle('nova-agency-native-hidden', hidden);}
  function column(el) {return el?.closest('.rsi-layout-wrapper > div');}
  function field(id, title) {
    const box = make('div','nova-agency-field'), label = make('label'), select = make('select'), hint = make('div','nova-agency-hint');
    label.htmlFor = id; label.textContent = title; select.id = id;
    hint.id = `${id}-hint`; hint.setAttribute('aria-live','polite'); select.setAttribute('aria-describedby',hint.id);
    box.append(label,select,hint); return {box,label,select,hint};
  }
  function mount(form, address) {
    const wrapper = address.closest('.rsi-text-input-wrapper'), dept = input(form,'province');
    if (!wrapper || !dept) return null;
    const method = field('nova-delivery-method',t.method), agency = field('nova-agency-select',t.choose);
    method.select.append(new Option(t.methodChoose,''),new Option(t.home,'home'),new Option(t.shalomDelivery,'shalom'),new Option(t.olvaDelivery,'olva'));
    dept.closest('.rsi-text-input-wrapper').after(method.box);
    wrapper.before(agency.box);
    const s = {form,address,wrapper,method,agency,key:null,provider:'',chosen:null,matches:[],homes:{},department:''};
    states.set(address,s);
    method.select.addEventListener('change', () => {
      const value = method.select.value;
      const radio = [...form.querySelectorAll('input[name="shippingRate"]')].find(r => value === 'shalom' ? /Shalom/i.test(r.value) : value === 'olva' ? /Olva/i.test(r.value) : !/Shalom|Olva/i.test(r.value));
      if (value && radio && !radio.checked) radio.click();
      method.select.removeAttribute('aria-invalid'); schedule();
    });
    agency.select.addEventListener('change', () => {
      s.chosen = agency.select.value === 'coordinate' ? 'coordinate' : s.matches.find(a=>a.id === agency.select.value) || null;
      const company = s.provider === 'shalom' ? 'Shalom' : 'Olva Courier';
      if (s.chosen === 'coordinate') {
        write(input(form,'city'),t.coordinateAddress); write(input(form,'civic_number'),t.coordinateAddress);
        write(address,`${company} — ${t.coordinateAddress}: ${dept.value}`); agency.hint.textContent=t.coordinateHint;
      } else if (s.chosen) {
        const a=s.chosen;
        write(input(form,'city'),a.province); write(input(form,'civic_number'),a.district);
        const prefix=`${company} — ${a.name}`, suffix=` — ${a.district}, ${a.province}, ${a.department}`;
        const street=a.name.includes(a.address)?'':' — '+a.address;
        const available=Math.max(0,250-prefix.length-suffix.length);
        write(address,prefix+(street.length>available?street.slice(0,Math.max(0,available-1))+'…':street)+suffix);
        agency.hint.textContent=`${a.address} · ${a.district}, ${a.province}`;
      } else {write(address,''); write(input(form,'city'),''); write(input(form,'civic_number'),''); agency.hint.textContent='';}
      agency.select.removeAttribute('aria-invalid');
    });
    return s;
  }
  function refreshForm(form) {
    const address=input(form,'address'); if (!address) return;
    const s=states.get(address)||mount(form,address); if (!s) return;
    const dept=input(form,'province').value.trim(), deptKey=canonical(dept), homeAllowed=['lima','callao'].includes(deptKey);
    s.method.select.querySelector('option[value="home"]').disabled=!homeAllowed;
    if(s.method.select.value==='home' && !homeAllowed) s.method.select.value='';
    const provider=s.method.select.value, key=[provider,deptKey,!!catalog,failed].join('|');
    hide(column(form.querySelector('.rsi-shipping-rates-wrapper')),true);
    hide(column(input(form,'city')),true);
    hide(column(input(form,'civic_number')),provider!=='home');
    hide(column(input(form,'note')),true);
    form.querySelectorAll('.rsi-custom-text').forEach(el=>hide(column(el),true));
    hide(s.wrapper,provider!=='home');
    s.agency.box.hidden=!['shalom','olva'].includes(provider);
    hide(column(address),!provider);
    if(s.key===key) return;
    if(s.provider==='home')s.homes[s.department]={address:address.value,district:input(form,'civic_number')?.value||''};
    s.key=key;s.provider=provider;s.department=deptKey;s.chosen=null;
    s.method.hint.textContent=provider==='home'?t.homeHint:provider?t.agencyPayment:dept&&!homeAllowed?t.agencyOnly:'';
    s.agency.select.removeAttribute('aria-invalid');
    if(provider==='home') {
      write(input(form,'city'),deptKey==='callao'?'Callao':'Lima');
      const saved=s.homes[deptKey]||{};
      write(input(form,'civic_number'),saved.district||'');write(address,saved.address||'');return;
    }
    write(address,'');write(input(form,'city'),'');write(input(form,'civic_number'),'');
    if(!provider) return;
    s.agency.label.textContent=provider==='shalom'?t.shalom:t.olva;
    s.agency.select.replaceChildren(new Option(t.choose,''));s.agency.select.disabled=true;s.agency.hint.textContent='';
    if(!dept){s.agency.select.options[0].textContent=t.locationFirst;return;}
    if(!catalog&&!failed){s.agency.select.options[0].textContent=t.loading;return;}
    s.matches=(catalog?.[provider]||[]).filter(a=>canonical(a.department)===deptKey).sort((a,b)=>a.province.localeCompare(b.province,'es')||a.district.localeCompare(b.district,'es')||a.name.localeCompare(b.name,'es'));
    let group=null;
    for(const a of s.matches) {
      if(!group||group.label!==a.province){group=make('optgroup');group.label=a.province;s.agency.select.append(group);}
      group.append(new Option(`${a.district} · ${a.name}${a.name.includes(a.address)?'':' — '+a.address}`,a.id));
    }
    s.agency.select.add(new Option(t.coordinate,'coordinate'));s.agency.select.disabled=false;
    s.agency.hint.textContent=s.matches.length?t.departmentHint:failed?t.unavailable:t.empty;
  }
  function refresh(){document.querySelectorAll(formSelector).forEach(refreshForm);}
  function schedule(){if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;refresh();});}
  function validate(form,e){
    refreshForm(form);const s=states.get(input(form,'address'));if(!s)return;
    const missingDept=!input(form,'province').value.trim();
    if(!missingDept && s.provider && (s.provider==='home'||s.chosen))return;
    e.preventDefault();e.stopImmediatePropagation();
    const control=missingDept?input(form,'province'):!s.provider?s.method.select:s.agency.select;
    control.setAttribute('aria-invalid','true');
    if(!s.provider)s.method.hint.textContent=t.methodChoose;else s.agency.hint.textContent=missingDept?t.locationFirst:t.choose;
    control.focus();
  }
  document.addEventListener('input',e=>{if(e.target.matches(`${formSelector} input#province`))schedule();});
  document.addEventListener('change',e=>{if(e.target.matches(`${formSelector} input#province,${formSelector} input[name="shippingRate"]`))schedule();});
  document.addEventListener('click',e=>{const b=e.target.closest(`${formSelector} .rsi-submit_button`);if(b)validate(b.closest('form'),e);},true);
  document.addEventListener('submit',e=>{if(e.target.matches(formSelector))validate(e.target,e);},true);
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  fetch(config.catalog,{credentials:'omit'}).then(r=>{if(!r.ok)throw new Error('catalog');return r.json();}).then(data=>{catalog=data;refresh();}).catch(()=>{failed=true;refresh();});
  refresh();
})();
